import { isEmpty, isObject } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import tabsHelper from '../../../common/config/tabs-helper'

const VALID_REQUEST_TYPES = ['TEMPORARY_TRAFFIC_REGULATION', 'TEMPORARY_TRAFFIC_REGULATION_EXCAVATION']
export default {
  mixins: [
    tabsHelper
  ],

  data () {
    return {
      cardsVisibility: {
        damages: false,
        installationOwner: false,
        trafficRegulationInvestor: false,
        repairInvestor: false
      },
      fieldsVisibilityConfig: {
        regulation_setter: {
          visible: false,
          row: null,
          column: null,
          colSpan: null
        },
        completed_excavation: {
          visible: false,
          row: null,
          column: null,
          colSpan: null
        },
        excavation_purpose: {
          visible: false
        },
        note: {
          visible: false
        },
        contractorOib: {
          visible: false
        },
        contractorAddress: {
          visible: false
        }
      },
      isLegalState: false
    }
  },

  computed: {
    dataFromRequest () {
      return {
        title: this.$t('road-maintenance/aggregator.data_from_request'),
        key: 'request-data',
        apiConfig: {
          post: {
            module: 'road-maintenance',
            route: 'traffic-regulation',
            method: 'post'
          }
        },
        modifyDataBeforeSend: (event) => this.modifyData(event),
        afterSave: () => this.redirectToTable(true),
        hiddenFormKeys: [
          'roads',
          'attachments',
          'latitude',
          'longitude',
          'regulation_setter_id'
        ],
        tabContent: [
          // Tab action buttons
          {
            key: 'tab-action-header',
            component: this.tabActionsComponent,
            title: this.$t('road-maintenance/aggregator.data_from_request'),
            showEditButtons: true,
            onCancelTabSave: () => this.redirectToTable()
          },
          // Location information
          {
            key: 'location',
            component: this.locationInformationComponent
          },
          // Applicant
          {
            key: 'applicant',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.applicant_information'),
            titleClasses: 'modified-title',
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'applicant_first_name',
                    label: this.$t('road-maintenance/aggregator.first_name') + '*',
                    validationPropertyKey: 'applicant.first_name',
                    row: 1,
                    column: 1,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_last_name',
                    label: this.$t('road-maintenance/aggregator.last_name') + '*',
                    validationPropertyKey: 'applicant.last_name',
                    row: 1,
                    column: 2,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'is_legal',
                    type: 'checkbox',
                    label: this.$t('road-maintenance/aggregator.legal_person'),
                    validationPropertyKey: 'applicant.is_legal',
                    onChange: (event) => {
                      const { data } = event || {}
                      this.isLegalState = !!data
                    },
                    row: 2,
                    column: 1,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_company_name',
                    label: this.$t('road-maintenance/aggregator.company_name') + '*',
                    validationPropertyKey: 'applicant.name',
                    row: 3,
                    column: 1,
                    colSpan: 2,
                    creatable: true,
                    editable: true,
                    visible: this.isLegalState
                  },
                  {
                    key: 'applicant_oib',
                    label: 'OIB*',
                    validationPropertyKey: 'applicant.oib',
                    row: this.isLegalState ? 4 : 3,
                    column: 1,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_address_street',
                    label: this.$t('road-maintenance/aggregator.address_street') + '*',
                    validationPropertyKey: 'applicant.address_street',
                    row: this.isLegalState ? 4 : 3,
                    column: 2,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_address_number',
                    label: this.$t('road-maintenance/aggregator.house_number') + '*',
                    validationPropertyKey: 'applicant.address_number',
                    row: this.isLegalState ? 5 : 4,
                    column: 1,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_phone_number',
                    label: this.$t('road-maintenance/aggregator.phone_number') + '*',
                    validationPropertyKey: 'applicant.phone',
                    row: this.isLegalState ? 5 : 4,
                    column: 2,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'applicant_email',
                    label: this.$t('road-maintenance/aggregator.email_address') + '*',
                    validationPropertyKey: 'applicant.email',
                    row: this.isLegalState ? 6 : 5,
                    column: 1,
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Request details
          {
            key: 'request-details',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.request_details'),
            titleClasses: 'modified-title',
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'work_type',
                    label: this.$t('road-maintenance/aggregator.type_of_works') + '*',
                    type: 'textarea',
                    row: 1,
                    column: 1,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'excavation_reason',
                    label: this.$t('road-maintenance/aggregator.excavation_purpose') + '*',
                    type: 'textarea',
                    row: 1,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: this.fieldsVisibilityConfig.excavation_purpose.visible
                  },
                  {
                    key: 'note',
                    label: this.$t('road-maintenance/excavation-service/tabs/handover/columns.note'),
                    type: 'textarea',
                    row: 1,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: this.fieldsVisibilityConfig.note.visible
                  },
                  {
                    type: 'plain-text',
                    text: this.$t('road-maintenance/aggregator.time_period'),
                    row: 2,
                    column: 1,
                    colSpan: 1.5,
                    class: 'time-period-text',
                    colClass: 'time-period-column',
                    visible: true
                  },
                  {
                    key: 'date_from',
                    type: 'datetime-picker',
                    subType: 'date',
                    format: FORMATS.date,
                    label: this.$t('road-maintenance/aggregator.date_from') + '*',
                    appendIcon: 'mdi-calendar',
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          date_from: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    row: 3,
                    column: 1,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'date_to',
                    type: 'datetime-picker',
                    subType: 'date',
                    format: FORMATS.date,
                    label: this.$t('road-maintenance/aggregator.date_to') + '*',
                    appendIcon: 'mdi-calendar',
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          date_to: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    row: 3,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'time_from',
                    type: 'datetime-picker',
                    subType: 'time',
                    format: FORMATS.timeShort,
                    label: this.$t('road-maintenance/aggregator.time_from'),
                    appendIcon: 'mdi-clock',
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.timeShort, true)) {
                        updateValidationErrors({
                          time_from: this.$t('base.invalid_time').replace(':format', FORMATS.timeShort)
                        })
                      }
                    },
                    row: 4,
                    column: 1,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'time_to',
                    type: 'datetime-picker',
                    subType: 'time',
                    format: FORMATS.timeShort,
                    label: this.$t('road-maintenance/aggregator.time_to'),
                    appendIcon: 'mdi-clock',
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.timeShort, true)) {
                        updateValidationErrors({
                          time_to: this.$t('base.invalid_time').replace(':format', FORMATS.timeShort)
                        })
                      }
                    },
                    row: 4,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'complete_repair',
                    label: this.$t('road-maintenance/aggregator.complete_renovation') + '*',
                    type: 'autocomplete',
                    tooltip: {
                      component: this.rehabilitationTooltipComponent,
                      color: 'transparent'
                    },
                    items: [
                      {
                        id: 1,
                        name: 'Da'
                      },
                      {
                        id: 0,
                        name: 'Ne'
                      }
                    ],
                    fetchInitial: false,
                    row: this.fieldsVisibilityConfig.completed_excavation.row,
                    column: this.fieldsVisibilityConfig.completed_excavation.column,
                    colSpan: this.fieldsVisibilityConfig.completed_excavation.colSpan,
                    visible: this.fieldsVisibilityConfig.completed_excavation.visible,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'regulation_setter',
                    label: this.$t('road-maintenance/aggregator.prp_set') + '*',
                    items: this.dropdownValues?.regulation_setter ?? [],
                    type: 'autocomplete',
                    onChange: (event) => this.manageInvestorsVisibilityByRequestTypeAndRegulationSetter(event?.selectedItem, this.requestType),
                    autocomplete_options: {
                      fetchInitial: false,
                      allowSearch: false,
                      custom_display_value: (item) => {
                        return item && item.description ? this.$t(item.description) : null
                      },
                      returnValue: 'object'
                    },
                    row: this.fieldsVisibilityConfig.regulation_setter.row,
                    column: this.fieldsVisibilityConfig.regulation_setter.column,
                    colSpan: this.fieldsVisibilityConfig.regulation_setter.colSpan,
                    visible: this.fieldsVisibilityConfig.regulation_setter.visible,
                    editable: true,
                    creatable: true
                  }
                ]
              }
            ]
          },
          // investitor privremene regulacije prometa
          {
            key: 'traffic_regulation_investor',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.traffic_regulation_investor'),
            visible: this.cardsVisibility.trafficRegulationInvestor,
            titleClasses: 'modified-title',
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'traffic_regulation_investor_name',
                    label: this.$t('road-maintenance/aggregator.name') + '*',
                    validationPropertyKey: 'traffic_regulation_investor.name',
                    row: 1,
                    column: 1,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'traffic_regulation_investor_address',
                    label: this.$t('road-maintenance/aggregator.address') + '*',
                    validationPropertyKey: 'traffic_regulation_investor.address',
                    row: 1,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'traffic_regulation_investor_oib',
                    label: 'OIB*',
                    validationPropertyKey: 'traffic_regulation_investor.oib',
                    row: 2,
                    column: 1,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'traffic_regulation_investor_phone_number',
                    label: this.$t('road-maintenance/aggregator.mobile_telephone') + '*',
                    validationPropertyKey: 'traffic_regulation_investor.phone',
                    row: 2,
                    column: 2,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'traffic_regulation_investor_email',
                    label: this.$t('road-maintenance/aggregator.email_address') + '*',
                    validationPropertyKey: 'traffic_regulation_investor.email',
                    row: 2,
                    column: 3,
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // investitor troškova sanacije prijekopa
          {
            key: 'repair_investor',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.investor_of_the_repair'),
            visible: this.cardsVisibility.repairInvestor,
            titleClasses: 'modified-title',
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'repair_investor_name',
                    label: this.$t('road-maintenance/aggregator.name') + '*',
                    validationPropertyKey: 'repair_investor.name',
                    row: 1,
                    column: 1,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'repair_investor_address',
                    label: this.$t('road-maintenance/aggregator.address') + '*',
                    validationPropertyKey: 'repair_investor.address',
                    row: 1,
                    column: 2,
                    colSpan: 1.5,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'repair_investor_oib',
                    label: 'OIB*',
                    validationPropertyKey: 'repair_investor.oib',
                    row: 2,
                    column: 1,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'repair_investor_phone_number',
                    label: this.$t('road-maintenance/aggregator.mobile_telephone') + '*',
                    validationPropertyKey: 'repair_investor.phone',
                    row: 2,
                    column: 2,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'repair_investor_email',
                    label: this.$t('road-maintenance/aggregator.email_address') + '*',
                    validationPropertyKey: 'repair_investor.email',
                    row: 2,
                    column: 3,
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Contractor
          {
            key: 'contractor',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.contractor'),
            titleClasses: 'modified-title',
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'contractor_name',
                    label: this.$t('road-maintenance/aggregator.name') + '*',
                    validationPropertyKey: 'contractor.name',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'contractor_responsible_person',
                    label: this.$t('road-maintenance/aggregator.contractor_responsible_person') + '*',
                    validationPropertyKey: 'contractor.responsible_person',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'contractor_phone_number',
                    label: this.$t('road-maintenance/aggregator.mobile_telephone') + '*',
                    validationPropertyKey: 'contractor.phone',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'contractor_email',
                    label: this.$t('road-maintenance/aggregator.email_address') + '*',
                    validationPropertyKey: 'contractor.email',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'contractor_address',
                    label: this.$t('road-maintenance/aggregator.address') + '*',
                    validationPropertyKey: 'contractor.address',
                    creatable: true,
                    editable: true,
                    visible: this.fieldsVisibilityConfig.contractorAddress.visible
                  },
                  {
                    key: 'contractor_oib',
                    label: 'OIB*',
                    validationPropertyKey: 'contractor.oib',
                    creatable: true,
                    editable: true,
                    visible: this.fieldsVisibilityConfig.contractorOib.visible
                  }
                ]
              }
            ]
          },
          // Authorized person
          {
            key: 'authorized-person',
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.authorized_person'),
            titleClasses: 'modified-title',
            visible: this.cardsVisibility.installationOwner,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'installation_owner_name',
                    label: this.$t('fleet/documents/prl_cargo.name_and_surname') + '*',
                    validationPropertyKey: 'installation_owner.name',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'installation_owner_phone_number',
                    label: this.$t('road-maintenance/aggregator.mobile_telephone') + '*',
                    validationPropertyKey: 'installation_owner.phone',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'installation_owner_email',
                    label: this.$t('road-maintenance/aggregator.email_address') + '*',
                    validationPropertyKey: 'installation_owner.email',
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Anticipated damage
          {
            key: 'road_damages',
            title: {
              text: this.$t('road-maintenance/aggregator.anticipated_damage')
            },
            isCreate: !this.$route.params.id,
            style: this.$vuetify.breakpoint.mobile
              ? {
                  marginTop: '25px'
                }
              : {
                  border: '1px solid #E5E7EB',
                  borderRadius: '16px',
                  padding: '24px'
                },
            visible: this.cardsVisibility.damages,
            component: this.anticipatedDamageComponent,
            dropdownValues: this.dropdownValues
          },
          // Attachments
          {
            key: 'attachments',
            component: this.attachmentsComponent,
            accept: '.jpg,.png,.pdf,.tif',
            attachmentsKey: 'attachments',
            baseLabel: 'Tip priloga',
            dropdownValues: this.dropdownValues,
            onFilesInput: (event) => this.onFilesInput(event)
          }
        ]
      }
    }
  },

  watch: {
    requestType: {
      handler (val) {
        if (val) {
          this.setFieldsAndCardsVisibilityByRequestType()
        }
      }
    },
    showRequestTypeSelectionView: {
      handler (val) {
        if (val) {
          this.$set(this.cardsVisibility, 'damages', false)
          this.$set(this.cardsVisibility, 'installationOwner', false)
          this.$set(this.cardsVisibility, 'trafficRegulationInvestor', false)
          this.$set(this.cardsVisibility, 'repairInvestor', false)
        }
      }
    }
  },

  methods: {
    setFieldsAndCardsVisibilityByRequestType () {
      if (this.requestType === VALID_REQUEST_TYPES[1]) {
        this.$set(this.fieldsVisibilityConfig.completed_excavation, 'visible', true)
        this.$set(this.fieldsVisibilityConfig.completed_excavation, 'row', 5)
        this.$set(this.fieldsVisibilityConfig.completed_excavation, 'column', 1)
        this.$set(this.fieldsVisibilityConfig.completed_excavation, 'colSpan', 1.5)

        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'visible', true)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'row', 5)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'column', 2)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'colSpan', 1.5)

        this.$set(this.fieldsVisibilityConfig.excavation_purpose, 'visible', true)
        this.$set(this.fieldsVisibilityConfig.note, 'visible', false)

        // show installation owner and damages cards when request type is PRP + Prijekop
        this.$set(this.cardsVisibility, 'installationOwner', true)
        this.$set(this.cardsVisibility, 'damages', true)
      }
      else {
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'visible', true)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'row', 5)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'column', 1)
        this.$set(this.fieldsVisibilityConfig.regulation_setter, 'colSpan', 1.5)

        this.$set(this.fieldsVisibilityConfig.completed_excavation, 'visible', false)

        this.$set(this.fieldsVisibilityConfig.excavation_purpose, 'visible', false)
        this.$set(this.fieldsVisibilityConfig.note, 'visible', true)

        this.$set(this.cardsVisibility, 'installationOwner', false)
        this.$set(this.cardsVisibility, 'damages', false)
      }
      this.manageInvestorsVisibilityByRequestTypeAndRegulationSetter(null, this.requestType)
    },

    modifyData (event) {
      try {
        const { copiedData } = event || {}

        if (copiedData && isObject(copiedData)) {
          // Modify attachments to send only type and file
          if (copiedData && copiedData.attachments && copiedData.attachments.length) {
            copiedData.attachments = copiedData.attachments
              .map((attachment) => {
                if (!attachment.new) {
                  return {
                    type_id: attachment?.type_id ?? null,
                    file_id: attachment?.file_id ?? null
                  }
                }
                else {
                  return {
                    type_id: attachment?.type_id ?? null,
                    file_id: null,
                    file: attachment.file || null
                  }
                }
              })
              .filter(Boolean)
          }

          // Modify other data
          copiedData.date_from = copiedData.date_from ? dateService.formatCustom(copiedData.date_from, FORMATS.date, FORMATS.isoDate) : null
          copiedData.date_to = copiedData.date_to ? dateService.formatCustom(copiedData.date_to, FORMATS.date, FORMATS.isoDate) : null
          copiedData.time_from = copiedData.time_from ? copiedData.time_from + ':00' : null
          copiedData.time_to = copiedData.time_to ? copiedData.time_to + ':00' : null
          copiedData.request_type = this.requestType ?? null
          copiedData.regulation_setter_id = copiedData?.regulation_setter?.id ?? copiedData?.regulation_setter ?? null
          delete copiedData.regulation_setter

          // group applicant data
          copiedData.applicant = {
            first_name: copiedData?.applicant_first_name ?? null,
            last_name: copiedData?.applicant_last_name ?? null,
            address_street: copiedData?.applicant_address_street ?? null,
            address_number: copiedData?.applicant_address_number ?? null,
            phone: copiedData?.applicant_phone_number ?? null,
            email: copiedData?.applicant_email ?? null,
            oib: copiedData?.applicant_oib ?? null,
            is_legal: !!copiedData?.is_legal
          }

          if (copiedData.is_legal) {
            copiedData.applicant.name = copiedData?.applicant_company_name || null
          }

          // group investor data to object
          if (this.cardsVisibility.trafficRegulationInvestor) {
            copiedData.traffic_regulation_investor = {
              name: copiedData?.traffic_regulation_investor_name ?? null,
              address: copiedData?.traffic_regulation_investor_address ?? null,
              oib: copiedData?.traffic_regulation_investor_oib ?? null,
              phone: copiedData?.traffic_regulation_investor_phone_number ?? null,
              email: copiedData?.traffic_regulation_investor_email ?? null
            }
          }
          if (this.cardsVisibility.repairInvestor) {
            copiedData.repair_investor = {
              name: copiedData?.repair_investor_name ?? null,
              address: copiedData?.repair_investor_address ?? null,
              oib: copiedData?.repair_investor_oib ?? null,
              phone: copiedData?.repair_investor_phone_number ?? null,
              email: copiedData?.repair_investor_email ?? null
            }
          }

          // group contractor data to object
          copiedData.contractor = {
            name: copiedData?.contractor_name ?? null,
            responsible_person: copiedData?.contractor_responsible_person ?? null,
            phone: copiedData?.contractor_phone_number ?? null,
            email: copiedData?.contractor_email ?? null
          }

          if (this.fieldsVisibilityConfig.contractorOib.visible && this.fieldsVisibilityConfig.contractorAddress.visible) {
            copiedData.contractor.oib = copiedData?.contractor_oib
            copiedData.contractor.address = copiedData?.contractor_address
          }

          // delete old values that are grouped in object previously
          delete copiedData.applicant_first_name
          delete copiedData.applicant_last_name
          delete copiedData.applicant_address_street
          delete copiedData.applicant_address_number
          delete copiedData.applicant_phone_number
          delete copiedData.applicant_email
          delete copiedData.applicant_oib
          delete copiedData.is_legal
          delete copiedData.applicant_company_name

          // traffic regulation investor values
          delete copiedData.traffic_regulation_investor_name
          delete copiedData.traffic_regulation_investor_address
          delete copiedData.traffic_regulation_investor_oib
          delete copiedData.traffic_regulation_investor_phone_number
          delete copiedData.traffic_regulation_investor_email

          // repair investor values
          delete copiedData.repair_investor_name
          delete copiedData.repair_investor_address
          delete copiedData.repair_investor_oib
          delete copiedData.repair_investor_phone_number
          delete copiedData.repair_investor_email

          // contractor field values
          delete copiedData.contractor_name
          delete copiedData.contractor_responsible_person
          delete copiedData.contractor_phone_number
          delete copiedData.contractor_email
          delete copiedData.contractor_oib
          delete copiedData.contractor_address

          // in second form type map installation owner, remove its old non-grouped fields and remove damages
          if (this.requestType === VALID_REQUEST_TYPES[1]) {
            copiedData.installation_owner = {
              name: copiedData?.installation_owner_name ?? null,
              phone: copiedData?.installation_owner_phone_number ?? null,
              email: copiedData?.installation_owner_email ?? null
            }

            delete copiedData.installation_owner_name
            delete copiedData.installation_owner_phone_number
            delete copiedData.installation_owner_email
          }

          if (copiedData?.roads?.length) {
            copiedData.roads.forEach(road => {
              // remove all damages that has 'checked' prop set to false
              // also remove 'checked' from each damage result
              if (road?.damages) {
                Object.keys(road.damages).forEach(damageKey => {
                  const damage = road.damages[damageKey]

                  if (!damage.checked) {
                    delete road.damages[damageKey]
                  }
                  else {
                    delete damage.checked
                  }
                })
              }
              // if damages is an empty object, remove it
              if (isEmpty(road?.damages)) {
                delete road.damages
              }
            })
          }

          // map roads to send only needed props
          if (copiedData?.roads) {
            copiedData.roads = copiedData?.roads.map(road => {
              const mappingObj = {
                id: road?.id?.id || road?.id || null,
                description: road?.description || null
              }
              // send damages only if at least one its property is filled and if its checked
              if (road?.damages) {
                mappingObj.damages = road.damages
              }

              return mappingObj
            })
          }
          return { ...copiedData }
        }
        return {}
      }
      catch (exception) {
        console.error(exception)
        return {}
      }
    },

    onFilesInput (event) {
      try {
        const { filesEvent, updateData, formData } = event || {}
        const newAttachments = formData && formData.attachments && formData.attachments.length ? formData.attachments : []
        if (filesEvent && typeof updateData === 'function') {
          const uploadedFiles = filesEvent.target.files
          const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf', 'image/tiff'] // Allowed MIME types
          const maxFileSize = 200 * 1024 * 1024 // 200MB in bytes
          const maxFileSizeInMb = 200

          if (!formData.attachments) {
            updateData({
              attachments: []
            })
          }

          Array.from(uploadedFiles).forEach(file => {
            if (!allowedTypes.includes(file.type)) {
              this.pushNotification(`${this.$t('road-maintenance/aggregator.allowed_file_types_message').replace(':types', allowedTypes.join(','))}!`)
              console.warn(`File type not allowed: ${file.name} (${file.type})`)
              return
            }

            if (file.size > maxFileSize) {
              this.pushNotification(`${this.$t('road-maintenance/aggregator.exceeding_file_size_message').replace(':file', file?.name || '-').replace(':size', maxFileSizeInMb + 'MB')}!`)
              console.warn(`File size exceeds ${maxFileSizeInMb + 'MB'}: ${file.name}`)
              return
            }

            newAttachments.push({
              type_id: 'type_' + file.name,
              new: true,
              file_name: file?.name ?? '-',
              file,
              image: {
                src: '/img/icons/pdf-icon.svg',
                style: {
                  maxWidth: '40px',
                  height: '40px'
                }
              }
            })
          })
          updateData({
            attachments: newAttachments
          })
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    redirectToTable (refreshTable = false) {
      this.showRequestTypeSelectionView = true
      // after creating new request redirect user to the table and refresh it
      if (refreshTable) {
        this.$emit('refresh-table')
        this.$emit('close')
      }
    }
  }
}
